// Цвет плитки игры по категории из базы: одни и те же цвета в главном меню и в рейтингах
export const TILE_COLOR: Record<string, string> = {
  Basics: '#3f6fb5',
  Attention: '#7a4fa3',
  Roulette: '#1f6b48',
  Blackjack: '#23795f',
  'Niu-Niu': '#b4493a',
  Baccarat: '#8e2f52',
  RussianPoker: '#2f4f86',
  TexasPoker: '#2f4f86',
  Dice: '#b5651d',
};

export const tileColor = (category: string): string => TILE_COLOR[category] ?? '#456d97';
